export const PROMISE_STATUS_PADDING = 3
export const PROMISE_STATUS_FAIL = 4
export const PRIVILEGE_PROMISE_ID = 5
export const PRIVILEGE_REFUND_ID = 6
